import React from "react";
import { NakiNigunHomeMainViewTemplate } from "themes/application/naki-nigun/components";

function NakiNigunHomeMainView(props) {
    return <NakiNigunHomeMainViewTemplate {...props} />;
}

export default NakiNigunHomeMainView;
